import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createLeaveType = async (data) => {
  const res = await axiosInstance.post("/api/leave-types-portal/create", data);
  return res.data;
};

export const getAllLeaveTypes = async (filters = {}) => {
  const res = await axiosInstance.get("/api/leave-types-portal/all", { params: filters });
  return res.data;
};

export const getActiveLeaveTypes = async () => {
  const res = await axiosInstance.get("/api/leave-types-portal/active");
  return res.data;
};

export const updateLeaveType = async (id, data) => {
  const res = await axiosInstance.put(`/api/leave-types-portal/update/${id}`, data);
  return res.data;
};

export const toggleLeaveTypeActive = async (id) => {
  const res = await axiosInstance.put(`/api/leave-types-portal/toggle/${id}`);
  return res.data;
};
